import { render, staticRenderFns } from "./VideoSlider.vue?vue&type=template&id=3c86aa70&"
import script from "./VideoSlider.vue?vue&type=script&lang=js&"
export * from "./VideoSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports